import { useElementSize } from "usehooks-ts";
import Widget from "../../../../components/baseWidget";
import styled from "styled-components";
import StreamIcon from "./streamIcon";
import { useMemo } from "react";
import useHappeningsContext from "../../hooks/useHappeningsContext";
import EventCard from "../eventCard";
import EmptyStateFallback from "./emptyStateFallback";
import { generateRandomId } from "../../../../helpers/utils";

const HappeningsEventStreamWidget = () => {
  const [containerRef, containerDims] = useElementSize();
  const { eventsData } = useHappeningsContext();

  const contentDims = useMemo(() => {
    const dims = { height: 0, width: 0 };
    if (containerDims.height) {
      dims.height = containerDims.height - 50;
      dims.width = containerDims.width - 50;
    }
    return dims;
  }, [containerDims]);

  return (
    <Widget ref={containerRef}>
      <WidgetContentWrapper
        style={{
          height: `${contentDims}px`,
          width: `${contentDims}px`
        }}
      >
        <div className="widget-title">
          <span className="icon">
            <StreamIcon />
          </span>
          <span className="title">What&apos;s Happening</span>
        </div>
        <div
          className={`widget-content ${eventsData.length > 0 ? "has-events" : "is-empty"}`}
          style={{ height: `${contentDims.height - 40}px` }}
        >
          {eventsData.length > 0 ? (
            eventsData
              .sort((a: any, b: any) => b.timestamp - a.timestamp)
              .map((d: any) => (
                <EventCard
                  key={`${d.timestamp}.${generateRandomId(10)}`}
                  icon={d.icon}
                  iconUrl={d.icon_url}
                  title={d.title}
                  message={d.message}
                  timestamp={d.timestamp}
                  variant={d.variant}
                />
              ))
          ) : (
            <EmptyStateFallback />
          )}
        </div>
      </WidgetContentWrapper>
    </Widget>
  );
};

export default HappeningsEventStreamWidget;

const WidgetContentWrapper = styled.div`
  .widget-title {
    display: flex;
    position: relative;
    bottom: 10px;
    height: 40px;
    align-items: center;
    .title {
      margin-top: 5px;
      font-size: 18px;
      color: #70d380;
    }
  }
  .widget-content {
    &.is-empty {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &.has-events {
      overflow: scroll;
    }
  }

  @media (max-width: 767px) {
    .widget-title {
      bottom: 5px;
      height: 32px;
      .title {
        font-size: 15px;
      }
    }
  }
`;
